import { useLayoutEffect, useRef } from 'react';
import { Button } from '../../../../components/ui/Button';
import { FormSection } from '../../../../components/ui/Form';
import { Icon } from '../../../../components/ui/Icon';
import { Tooltip } from '../../../../components/ui/Tooltip';
import { Upload } from '../../../../components/ui/Upload';
import type { useSchoolLogo } from './useSchoolLogo';
import styles from './Page.module.css';

export function SchoolLogoSetting({ logo, report }: { logo: ReturnType<typeof useSchoolLogo>; report: (message: string) => void }) {
  const tile = useRef<HTMLDivElement | null>(null);
  const restoreFocus = useRef(false);
  const focusPicker = () => (tile.current?.querySelector<HTMLButtonElement>('[data-logo-replace]') ?? tile.current?.querySelector<HTMLButtonElement>('button'))?.focus();
  useLayoutEffect(() => {
    if (!logo.preview && restoreFocus.current) {
      restoreFocus.current = false;
      focusPicker();
    }
  }, [logo.preview]);
  return <FormSection className={styles.settingSection} title="学校Logo">
    <div aria-atomic="true" aria-live="polite" className={`${styles.copyFeedback} ${styles.logoFeedback}`} data-failed={logo.status === 'failed' || undefined} id="school-logo-feedback">
      {logo.status === 'reading' ? '正在读取图片…' : logo.status === 'saving' ? '保存中…' : logo.status === 'saved' ? '已保存' : logo.status === 'failed' ? <><span>保存失败</span><Button aria-label="重试保存学校 Logo" className={styles.copyRetry} onClick={() => { focusPicker(); void logo.retry(); }} size="small" type="default">重试</Button></> : null}
    </div>
    <div className={styles.logoTile} data-filled={Boolean(logo.preview) || undefined} ref={tile}>
      <Upload accept="image/jpeg,image/png" ariaLabel="上传学校 Logo" className={styles.logoUpload} maxCount={1} maxSize={2 * 1024 * 1024} onSelect={logo.select} onSizeExceed={() => report('学校 Logo 大小不能超过 2 MB。')} size="compact" variant="picture-card" />
      {logo.preview ? <img alt="学校 Logo 缩略图" className={styles.logoThumbnail} src={logo.preview} /> : null}
      {logo.preview ? <div className={styles.logoActions}>
        <Tooltip content="替换"><span><Button aria-label="替换学校 Logo" className={styles.logoAction} data-logo-replace onClick={() => tile.current?.querySelector<HTMLInputElement>('input[type="file"]')?.click()} size="small" type="default"><Icon name="edit" size="md" /></Button></span></Tooltip>
        <Tooltip content="移除"><span><Button aria-label="移除 学校 Logo" className={styles.logoAction} onClick={() => { restoreFocus.current = true; void logo.remove(); }} size="small" type="default"><Icon name="delete-filled" size="md" /></Button></span></Tooltip>
      </div> : <span className={styles.logoCaption}>点击上传</span>}
    </div>
    <p className={styles.hint}>支持上传jpg、jpeg、png图片格式，图片大小不超过2M。</p>
  </FormSection>;
}
